<template>
  <div class="root">
    <div v-if="href">
      <i class="el-icon-download"></i>
      Download Attachment:
      <a :href="href">{{ fileName }}</a>
    </div>
    <div v-else>
      No Attachments
    </div>
  </div>
</template>

<script>
export default {
  name: "FileDownloadCard",
  props: {
    href: String
  },
  computed: {
    fileName() {
      return this.href.split("/").pop();
    }
  }
};
</script>

<style scoped>
.root {
  padding: 8px 0;
  font-size: 14px;
  color: #a2a2a2;
}
</style>